/**
 * Safely parse JSON from localStorage with a fallback default.
 * Prevents app crashes from corrupted cached data.
 */
export function safeJsonParse<T>(raw: string | null, fallback: T): T {
  if (!raw) return fallback;
  try {
    return JSON.parse(raw) as T;
  } catch (err) {
    console.warn("[safeJsonParse] Corrupted data, using fallback:", err);
    return fallback;
  }
}

/** Read a localStorage key and safely parse it, returning fallback on any error. */
export function readLocalJson<T>(key: string, fallback: T): T {
  try {
    return safeJsonParse(localStorage.getItem(key), fallback);
  } catch {
    return fallback;
  }
}
